// import React, { useState } from 'react';
// import { TabContent, TabPane, Nav, NavItem, NavLink } from 'reactstrap';
// import classnames from 'classnames';

// // Import icons
// import cnIconReact from '../../../images/icons/icon_react_js.svg';
// import cnIconNext from '../../../images/icons/icon_nextjs.svg';       // Add Next.js icon
// import cnIconTailwind from '../../../images/icons/icon_tailwind.svg'; // Add Tailwind icon
// import cnIconScss from '../../../images/icons/icon_scss.svg';         // Add SCSS icon
// import cnIconHtml from '../../../images/icons/icon_html.svg';         // Add HTML icon
// import cnIconJs from '../../../images/icons/icon_javascript.svg';
// import cnIconTs from '../../../images/icons/icon_typescript.svg';

// import cnIconExpress from '../../../images/icons/icon_express.svg';   // Add Express icon
// import cnIconNode from '../../../images/icons/icon_nodejs.svg';       // Add Node.js icon
// import cnIconFirebase from '../../../images/icons/icon_firebase.svg'; // Add Firebase icon

// import cnIconMysql from '../../../images/icons/icon_mysql.svg';       // Add MySQL icon
// import cnIconMongo from '../../../images/icons/icon_mongo.svg';       // Add MongoDB icon
// import cnIconPostgres from '../../../images/case/icon_elephent.svg';  // PostgreSQL elephant

// import cnIconSwift from '../../../images/icons/icon_swift.svg';
// import cnIconKotlin from '../../../images/icons/icon_kotlin.svg';     // Add Kotlin icon
// import cnIconReactNative from '../../../images/icons/icon_react_native.svg'; // React Native icon

// import cnIconPremier from '../../../images/icons/icon_premiere.svg';  // Adobe Premiere
// import cnIconPs from '../../../images/icons/icon_photoshop.svg';      // Photoshop
// import cnIconAe from '../../../images/icons/icon_aftereffects.svg';   // After Effects
// import cnIconFigma from '../../../images/icons/icon_figma.svg';       // Figma
// import cnIconCanva from '../../../images/icons/icon_canva.svg';       // Canva
// import cnIconBlender from '../../../images/icons/icon_blender.svg';   // Blender

// import cnIconWordpress from '../../../images/icons/icon_wordpress.svg'; // WordPress
// import cnIconShopify from '../../../images/icons/icon_shopify.svg';   // Shopify
// import cnIconStripe from '../../../images/icons/icon_stripe.svg';     // Stripe
// import cnIconWoo from '../../../images/icons/icon_woocommerce.svg'; // WooCommerce

// import Bg from '../../../images/shapes/shape_title_under_line.svg';
// import { useParams } from 'react-router-dom';


// // ✅ Category Wise Technologies
// const TechnologyList = {
//   frontend: [
//     { id: '1', title: 'React', sIcon: cnIconReact },
//     { id: '2', title: 'Next.js', sIcon: cnIconNext },
//     { id: '3', title: 'TailwindCSS', sIcon: cnIconTailwind },
//     { id: '4', title: 'SCSS', sIcon: cnIconScss },
//     { id: '6', title: 'JavaScript', sIcon: cnIconJs },
//     { id: '7', title: 'TypeScript', sIcon: cnIconTs },
//   ],
//   backend: [
//     { id: '1', title: 'Express.js', sIcon: cnIconExpress },
//     { id: '2', title: 'Node.js', sIcon: cnIconNode },
//     { id: '3', title: 'JavaScript', sIcon: cnIconJs },
//   ],
//   database: [
//     { id: '1', title: 'MySQL', sIcon: cnIconMysql },
//     { id: '2', title: 'Firebase', sIcon: cnIconFirebase },
//     { id: '3', title: 'MongoDB', sIcon: cnIconMongo },
//     { id: '4', title: 'PostgreSQL', sIcon: cnIconPostgres },
//   ],
//   mobile: [
//     { id: '1', title: 'React Native', sIcon: cnIconReactNative },
//   ],
//   CMS: [
//     { id: '1', title: 'WordPress', sIcon: cnIconWordpress },
//     { id: '2', title: 'Shopify', sIcon: cnIconShopify },
//   ],
//   graphic: [
//     { id: '1', title: 'Adobe Premiere Pro CC', sIcon: cnIconPremier },
//     { id: '2', title: 'Adobe Photoshop', sIcon: cnIconPs },
//     { id: '3', title: 'Adobe After Effects', sIcon: cnIconAe },
//     { id: '4', title: 'Figma', sIcon: cnIconFigma },
//     { id: '5', title: 'Canva', sIcon: cnIconCanva },
//     { id: '6', title: 'Blender', sIcon: cnIconBlender },
//   ]
// };

// const TechnologySection = () => {
//   const [activeTab, setActiveTab] = useState('1');
//   const { slug } = useParams()
//   console.log(slug);
//   const toggle = tab => { if (activeTab !== tab) setActiveTab(tab); };

//   // 🔁 Reusable Renderer
//   const renderTechList = (list) => (
//     <div className="row justify-content-center">
//       {list.map((tech, idx) => (
//         <div className="col-lg-2 col-md-3 col-sm-4 col-6" key={idx}>
//           <div className="iconbox_block text-center p-0 shadow-none bg-transparent">
//             <div className="iconbox_icon">
//               <img src={tech.sIcon} alt={tech.title} />
//             </div>
//             <div className="iconbox_content">
//               <h5>{tech.title}</h5>
//             </div>
//           </div>
//         </div>
//       ))}
//     </div>
//   );

//   return (
//     <div className="section_space">
//       <div className="heading_block text-center">
//         <div className="heading_focus_text has_underline d-inline-flex"
//              style={{ backgroundImage: `url(${Bg})` }}>
//           Our Technologies
//         </div>
//         <h2 className="heading_text mb-0">
//           We Use <mark>Technologies</mark>
//         </h2>
//       </div>

//       <div className="tab_block_wrapper">
//         <Nav tabs className="nav justify-content-center">
//           <NavItem><NavLink className={classnames({ active: activeTab === '1' })} onClick={() => toggle('1')}>Frontend</NavLink></NavItem>
//           <NavItem><NavLink className={classnames({ active: activeTab === '2' })} onClick={() => toggle('2')}>Backend</NavLink></NavItem>
//           <NavItem><NavLink className={classnames({ active: activeTab === '3' })} onClick={() => toggle('3')}>Database</NavLink></NavItem>
//           <NavItem><NavLink className={classnames({ active: activeTab === '4' })} onClick={() => toggle('4')}>Mobile</NavLink></NavItem>
//           <NavItem><NavLink className={classnames({ active: activeTab === '5' })} onClick={() => toggle('5')}>CMS</NavLink></NavItem>
//           <NavItem><NavLink className={classnames({ active: activeTab === '6' })} onClick={() => toggle('6')}>Graphics</NavLink></NavItem>
//         </Nav>

//         <TabContent activeTab={activeTab}>
//           <TabPane tabId="1">{renderTechList(TechnologyList.frontend)}</TabPane>
//           <TabPane tabId="2">{renderTechList(TechnologyList.backend)}</TabPane>
//           <TabPane tabId="3">{renderTechList(TechnologyList.database)}</TabPane>
//           <TabPane tabId="4">{renderTechList(TechnologyList.mobile)}</TabPane>
//           <TabPane tabId="5">{renderTechList(TechnologyList.CMS)}</TabPane>
//           <TabPane tabId="6">{renderTechList(TechnologyList.graphic)}</TabPane>
//         </TabContent>
//       </div>
//     </div>
//   );
// };

// export default TechnologySection;



// import React, { useState } from 'react';
// import { TabContent, TabPane, Nav, NavItem, NavLink } from 'reactstrap';
// import classnames from 'classnames';

// // Import icons
// import cnIconReact from '../../../images/icons/icon_react_js.svg';
// import cnIconNext from '../../../images/icons/icon_nextjs.svg';       // Add Next.js icon
// import cnIconTailwind from '../../../images/icons/icon_tailwind.svg'; // Add Tailwind icon
// import cnIconScss from '../../../images/icons/icon_scss.svg';         // Add SCSS icon
// import cnIconHtml from '../../../images/icons/icon_html.svg';         // Add HTML icon
// import cnIconJs from '../../../images/icons/icon_javascript.svg';
// import cnIconTs from '../../../images/icons/icon_typescript.svg';

// import cnIconExpress from '../../../images/icons/icon_express.svg';   // Add Express icon
// import cnIconNode from '../../../images/icons/icon_nodejs.svg';       // Add Node.js icon
// import cnIconFirebase from '../../../images/icons/icon_firebase.svg'; // Add Firebase icon

// import cnIconMysql from '../../../images/icons/icon_mysql.svg';       // Add MySQL icon
// import cnIconMongo from '../../../images/icons/icon_mongo.svg';       // Add MongoDB icon
// import cnIconPostgres from '../../../images/case/icon_elephent.svg';  // PostgreSQL elephant

// import cnIconSwift from '../../../images/icons/icon_swift.svg';
// import cnIconKotlin from '../../../images/icons/icon_kotlin.svg';     // Add Kotlin icon
// import cnIconReactNative from '../../../images/icons/icon_react_native.svg'; // React Native icon

// import cnIconPremier from '../../../images/icons/icon_premiere.svg';  // Adobe Premiere
// import cnIconPs from '../../../images/icons/icon_photoshop.svg';      // Photoshop
// import cnIconAe from '../../../images/icons/icon_aftereffects.svg';   // After Effects
// import cnIconFigma from '../../../images/icons/icon_figma.svg';       // Figma
// import cnIconCanva from '../../../images/icons/icon_canva.svg';       // Canva
// import cnIconBlender from '../../../images/icons/icon_blender.svg';   // Blender

// import cnIconWordpress from '../../../images/icons/icon_wordpress.svg'; // WordPress
// import cnIconShopify from '../../../images/icons/icon_shopify.svg';   // Shopify
// import cnIconStripe from '../../../images/icons/icon_stripe.svg';     // Stripe
// import cnIconWoo from '../../../images/icons/icon_woocommerce.svg'; // WooCommerce

// import Bg from '../../../images/shapes/shape_title_under_line.svg';
// import { useParams } from 'react-router-dom';

// // ✅ Technology Definitions
// const Technologies = {
//   react: { id: '1', title: 'React', sIcon: cnIconReact },
//   nextjs: { id: '2', title: 'Next.js', sIcon: cnIconNext },
//   tailwind: { id: '3', title: 'TailwindCSS', sIcon: cnIconTailwind },
//   scss: { id: '4', title: 'SCSS', sIcon: cnIconScss },
//   js: { id: '6', title: 'JavaScript', sIcon: cnIconJs },
//   ts: { id: '7', title: 'TypeScript', sIcon: cnIconTs },
//   express: { id: '8', title: 'Express.js', sIcon: cnIconExpress },
//   node: { id: '9', title: 'Node.js', sIcon: cnIconNode },
//   mysql: { id: '10', title: 'MySQL', sIcon: cnIconMysql },
//   firebase: { id: '11', title: 'Firebase', sIcon: cnIconFirebase },
//   mongodb: { id: '12', title: 'MongoDB', sIcon: cnIconMongo },
//   postgresql: { id: '13', title: 'PostgreSQL', sIcon: cnIconPostgres },
//   reactnative: { id: '14', title: 'React Native', sIcon: cnIconReactNative },
//   wordpress: { id: '15', title: 'WordPress', sIcon: cnIconWordpress },
//   shopify: { id: '16', title: 'Shopify', sIcon: cnIconShopify },
//   woocommerce: { id: '17', title: 'WooCommerce', sIcon: cnIconWoo },
// };

// // ✅ Slug-based Technology Mapping
// const getTechnologiesBySlug = (slug) => {
//   switch(slug) {
//     case 'web-development':
//       return [
//         Technologies.react,
//         Technologies.nextjs,
//         Technologies.tailwind,
//         Technologies.scss,
//         Technologies.js,
//         Technologies.ts,
//         Technologies.express,
//         Technologies.node,
//         Technologies.mysql,
//         Technologies.firebase,
//         Technologies.mongodb,
//         Technologies.postgresql
//       ];
//     case 'app-development':
//       return [
//         Technologies.reactnative,
//         Technologies.express,
//         Technologies.node
//       ];
//     case 'e-commerce-solutions':
//       return [
//         Technologies.wordpress,
//         Technologies.shopify,
//         Technologies.woocommerce
//       ];
//     case 'custom-software':
//       return [
//         Technologies.react,
//         Technologies.nextjs,
//         Technologies.tailwind,
//         Technologies.scss,
//         Technologies.js,
//         Technologies.ts,
//         Technologies.express,
//         Technologies.node,
//         Technologies.mysql,
//         Technologies.firebase,
//         Technologies.reactnative,
//         Technologies.mongodb,
//         Technologies.postgresql
//       ];
//     default:
//       return [];
//   }
// };

// const TechnologySection = () => {
//   const { slug } = useParams();
//   const technologies = getTechnologiesBySlug(slug);

//   // 🔁 Reusable Renderer
//   const renderTechList = (list) => (
//     <div className="row justify-content-center">
//       {list.map((tech, idx) => (
//         <div className="col-lg-2 col-md-3 col-sm-4 col-6" key={idx}>
//           <div className="iconbox_block text-center p-0 shadow-none bg-transparent">
//             <div className="iconbox_icon">
//               <img src={tech.sIcon} alt={tech.title} />
//             </div>
//             <div className="iconbox_content">
//               <h5>{tech.title}</h5>
//             </div>
//           </div>
//         </div>
//       ))}
//     </div>
//   );

//   return (
//     <div className="section_space">
//       <div className="heading_block text-center">
//         <div className="heading_focus_text has_underline d-inline-flex"
//              style={{ backgroundImage: `url(${Bg})` }}>
//           Our Technologies
//         </div>
//         <h2 className="heading_text mb-0">
//           We Use <mark>Technologies</mark>
//         </h2>
//       </div>

//       <div className="tab_block_wrapper">
//         {technologies.length > 0 ? (
//           renderTechList(technologies)
//         ) : (
//           <div className="text-center">
//             <p>No technologies found for this category.</p>
//           </div>
//         )}
//       </div>
//     </div>
//   );
// };

// export default TechnologySection;


import React, { useState } from 'react';
import { TabContent, TabPane, Nav, NavItem, NavLink } from 'reactstrap';
import classnames from 'classnames';

// Import icons
import cnIconReact from '../../../images/icons/icon_react_js.svg';
import cnIconNext from '../../../images/icons/icon_nextjs.svg';       // Add Next.js icon
import cnIconTailwind from '../../../images/icons/icon_tailwind.svg'; // Add Tailwind icon
import cnIconScss from '../../../images/icons/icon_scss.svg';         // Add SCSS icon
import cnIconHtml from '../../../images/icons/icon_html.svg';         // Add HTML icon
import cnIconJs from '../../../images/icons/icon_javascript.svg';
import cnIconTs from '../../../images/icons/icon_typescript.svg';

import cnIconExpress from '../../../images/icons/icon_express.svg';   // Add Express icon
import cnIconNode from '../../../images/icons/icon_nodejs.svg';       // Add Node.js icon
import cnIconFirebase from '../../../images/icons/icon_firebase.svg'; // Add Firebase icon

import cnIconMysql from '../../../images/icons/icon_mysql.svg';       // Add MySQL icon
import cnIconMongo from '../../../images/icons/icon_mongo.svg';       // Add MongoDB icon
import cnIconPostgres from '../../../images/case/icon_elephent.svg';  // PostgreSQL elephant

import cnIconSwift from '../../../images/icons/icon_swift.svg';
import cnIconKotlin from '../../../images/icons/icon_kotlin.svg';     // Add Kotlin icon
import cnIconReactNative from '../../../images/icons/icon_react_native.svg'; // React Native icon

import cnIconPremier from '../../../images/icons/icon_premiere.svg';  // Adobe Premiere
import cnIconPs from '../../../images/icons/icon_photoshop.svg';      // Photoshop
import cnIconAe from '../../../images/icons/icon_aftereffects.svg';   // After Effects
import cnIconFigma from '../../../images/icons/icon_figma.svg';       // Figma
import cnIconCanva from '../../../images/icons/icon_canva.svg';       // Canva
import cnIconBlender from '../../../images/icons/icon_blender.svg';   // Blender

import cnIconWordpress from '../../../images/icons/icon_wordpress.svg'; // WordPress
import cnIconShopify from '../../../images/icons/icon_shopify.svg';   // Shopify
import cnIconStripe from '../../../images/icons/icon_stripe.svg';     // Stripe
import cnIconWoo from '../../../images/icons/icon_woocommerce.svg'; // WooCommerce

import Bg from '../../../images/shapes/shape_title_under_line.svg';
import { useParams } from 'react-router-dom';

// ✅ Technology Definitions
const Technologies = {
  'web-development-services': [
    { id: '1', title: 'React', sIcon: cnIconReact },
    { id: '2', title: 'Next.js', sIcon: cnIconNext },
    { id: '3', title: 'TailwindCSS', sIcon: cnIconTailwind },
    { id: '4', title: 'SCSS', sIcon: cnIconScss },
    { id: '5', title: 'JavaScript', sIcon: cnIconJs },
    { id: '6', title: 'TypeScript', sIcon: cnIconTs },
    { id: '7', title: 'Express.js', sIcon: cnIconExpress },
    { id: '8', title: 'Node.js', sIcon: cnIconNode },
    { id: '9', title: 'MySQL', sIcon: cnIconMysql },
    { id: '10', title: 'Firebase', sIcon: cnIconFirebase },
    { id: '11', title: 'MongoDB', sIcon: cnIconMongo },
    { id: '12', title: 'PostgreSQL', sIcon: cnIconPostgres },
  ],
  'app-development-services': [
    { id: '1', title: 'React Native', sIcon: cnIconReactNative },
    { id: '2', title: 'Express.js', sIcon: cnIconExpress },
    { id: '3', title: 'Node.js', sIcon: cnIconNode },
    { id: '4', title: 'MongoDB', sIcon: cnIconMongo },
  ],
  'e-commerce-solutions-services': [
    { id: '1', title: 'WordPress', sIcon: cnIconWordpress },
    { id: '2', title: 'Shopify', sIcon: cnIconShopify },
    { id: '3', title: 'WooCommerce', sIcon: cnIconWoo },
  ],
  'custom-software-services': [
    { id: '1', title: 'React', sIcon: cnIconReact },
    { id: '2', title: 'Next.js', sIcon: cnIconNext },
    { id: '3', title: 'TailwindCSS', sIcon: cnIconTailwind },
    { id: '4', title: 'SCSS', sIcon: cnIconScss },
    { id: '5', title: 'JavaScript', sIcon: cnIconJs },
    { id: '6', title: 'TypeScript', sIcon: cnIconTs },
    { id: '7', title: 'Express.js', sIcon: cnIconExpress },
    { id: '8', title: 'Node.js', sIcon: cnIconNode },
    { id: '9', title: 'MySQL', sIcon: cnIconMysql },
    { id: '10', title: 'Firebase', sIcon: cnIconFirebase },
    { id: '11', title: 'React Native', sIcon: cnIconReactNative },
    { id: '12', title: 'MongoDB', sIcon: cnIconMongo },
    { id: '13', title: 'PostgreSQL', sIcon: cnIconPostgres },
  ]
};

const TechnologySection = () => {
  const { slug } = useParams();
  
  // If slug is not in our Technologies object, don't render anything
  if (!Technologies[slug]) {
    return null;
  }

  // 🔁 Reusable Renderer
  const renderTechList = (list) => (
    <div className="row justify-content-center">
      {list.map((tech, idx) => (
        <div className="col-lg-2 col-md-3 col-sm-4 col-6" key={idx}>
          <div className="iconbox_block text-center p-0 shadow-none bg-transparent">
            <div className="iconbox_icon">
              <img src={tech.sIcon} alt={tech.title} />
            </div>
            <div className="iconbox_content">
              <h5>{tech.title}</h5>
            </div>
          </div>
        </div>
      ))}
    </div>
  );

  return (
    <div className="section_space">
      <div className="heading_block text-center">
        <div className="heading_focus_text has_underline d-inline-flex"
             style={{ backgroundImage: `url(${Bg})` }}>
          Our Technologies
        </div>
        <h2 className="heading_text mb-0">
          We Use <mark>Technologies</mark>
        </h2>
      </div>

      <div className="tab_block_wrapper">
        {renderTechList(Technologies[slug])}
      </div>
    </div>
  );
};

export default TechnologySection;